<script lang="ts">
  import Login from "$routes/Login.svelte";
  import Register from "$routes/Register.svelte";
  import Landing from "$routes/Landing.svelte";
  import Welcome from "$routes/Welcome.svelte";
  import Demo from "$routes/Demo.svelte";
  import BotTour from "$routes/BotTour.svelte";
  import Dashboard from "$routes/Dashboard.svelte";
  import Transactions from "$routes/Transactions.svelte";
  import Insights from "$routes/Insights.svelte";
  import Categories from "$routes/Categories.svelte";
  import Settings from "$routes/Settings.svelte";
  import Workspaces from "$routes/Workspaces.svelte";
  import Pricing from "$routes/Pricing.svelte";
  import Upgrade from "$routes/Upgrade.svelte";
  import Recurrences from "$routes/Recurrences.svelte";
  import Loyalty from "$routes/Loyalty.svelte";
  import NotFound from "$routes/NotFound.svelte";
  import AuthGuard from "$lib/components/AuthGuard.svelte";
  import ToastContainer from "$lib/components/ToastContainer.svelte";
  import Onboarding from "$lib/components/Onboarding.svelte";
  import InstallPrompt from "$lib/components/InstallPrompt.svelte";
  import FeedbackButton from "$lib/components/FeedbackButton.svelte";
  import DemoBanner from "$lib/components/DemoBanner.svelte";
  import BotTourController from "$lib/components/BotTourController.svelte";
  import { auth } from "$lib/stores/auth.svelte";
  import { router } from "$lib/router.svelte";

  let showOnboarding = $state(false);

  $effect(() => {
    auth.bootstrap();
  });

  $effect(() => {
    if (auth.user && !localStorage.getItem("takite.onboarded")) {
      showOnboarding = true;
    }
  });
</script>

{#if router.path === "/login"}
  <Login />
{:else if router.path === "/register"}
  <Register />
{:else if router.path === "/demo"}
  <Demo />
{:else if router.path === "/bot-tour"}
  <BotTour />
{:else if router.path === "/welcome"}
  <AuthGuard><Welcome /></AuthGuard>
{:else if router.path === "/landing"}
  <Landing />
{:else if router.path === "/transactions"}
  <AuthGuard><Transactions /></AuthGuard>
{:else if router.path === "/insights"}
  <AuthGuard><Insights /></AuthGuard>
{:else if router.path === "/categories"}
  <AuthGuard><Categories /></AuthGuard>
{:else if router.path === "/workspaces"}
  <AuthGuard><Workspaces /></AuthGuard>
{:else if router.path === "/pricing"}
  <AuthGuard><Pricing /></AuthGuard>
{:else if router.path === "/upgrade"}
  <AuthGuard><Upgrade /></AuthGuard>
{:else if router.path === "/dashboard"}
  <AuthGuard><Dashboard /></AuthGuard>
{:else if router.path === "/recorrencias"}
  <AuthGuard><Recurrences /></AuthGuard>
{:else if router.path === "/fidelidade"}
  <AuthGuard><Loyalty /></AuthGuard>
{:else if router.path === "/settings"}
  <AuthGuard><Settings /></AuthGuard>
{:else if router.path === "/dashboard"}
  <AuthGuard><Dashboard /></AuthGuard>
{:else if router.path === "/"}
  {#if auth.loading}
    <!-- aguarda bootstrap silenciosamente -->
  {:else if auth.user}
    <AuthGuard><Dashboard /></AuthGuard>
  {:else}
    <Landing />
  {/if}
{:else}
  <NotFound />
{/if}

{#if showOnboarding}
  <Onboarding onDone={() => (showOnboarding = false)} />
{/if}

<ToastContainer />
<DemoBanner />
<BotTourController />
<InstallPrompt />
{#if auth.user}
  <FeedbackButton />
{/if}
